<template>
  <div class="footer-container container">
    <div class="footer-message">
      <p class="small">&copy; {{ year }} Donut World. All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
const moment = require("moment");
export default {
  name: "Footer",
  data() {
    return {
      year: false
    };
  },
  mounted() {
    this.year = moment().format("YYYY");
  }
};
</script>

<style lang="scss">
.footer-container {
  text-align: right;
}
.footer-message {
  padding: 20px 0;
  p {
    margin: 0;
  }
}
</style>
